/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D1tInputs */

const en_mk_sol_ukm_d1t = /** @type {(inputs: Mk_Sol_Ukm_D1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06:30: the sales recap is already waiting`)
};

const id_mk_sol_ukm_d1t = /** @type {(inputs: Mk_Sol_Ukm_D1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06.30: rekap penjualan sudah menunggu`)
};

/**
* | output |
* | --- |
* | "06:30: the sales recap is already waiting" |
*
* @param {Mk_Sol_Ukm_D1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d1t = /** @type {((inputs?: Mk_Sol_Ukm_D1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d1t(inputs)
	return en_mk_sol_ukm_d1t(inputs)
});